module.exports = __webpack_public_path__ + "static/DEV1-3fa136c9dadad48b8dc9409459e5f72c.png";